import { useSession } from "@hooks/useSession";
import { useWSStore } from "../../store";
import {
  GrowthAttributionDetails,
  GrowthSourceNames
} from "../../utils/growthAttribution";
import { analyticsService } from "../services/analyticsService";

type SignUpProperties = {
  growthAttributionDetails?: GrowthAttributionDetails;
  signUpMethod?: "Email" | "Google";
};

// spec: https://www.notion.so/wingspan/fe955d2904ec47aa8f48d4aae43bc4ef?v=6fa33777de0341c093feb16515a629bb
export const useTrackSignUp = () => {
  const store = useWSStore();
  const { accountId } = useSession();

  return (properties?: SignUpProperties) => {
    const growthAttributionDetails: GrowthAttributionDetails =
      properties?.growthAttributionDetails ||
        store.growthAttributionDetails || {
          growthSource: GrowthSourceNames.Content
        };

    const props = {
      growth_source: growthAttributionDetails.growthSource,
      growth_name: growthAttributionDetails.growthName,
      growth_user_id: growthAttributionDetails.growthUserId,
      signup_method: properties?.signUpMethod || store.signUpMethod || "Email"
    };

    analyticsService.track("Signed Up", props);
    analyticsService.identify(accountId, props);
  };
};
